// extracted by mini-css-extract-plugin
export default {"actionButtons":"FooterActionButtons_actionButtons__T5oc8"};